/**
 * @generated SignedSource<<13e05ab0ce5605285b330cc622cefb33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemPriority_todo$data = {
  readonly priority: TodoPriority;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoListItemPriority_todo";
};
export type TodoListItemPriority_todo$key = {
  readonly " $data"?: TodoListItemPriority_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemPriority_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemPriority_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "1ce34541c1306776079bf37402a6ace7";

export default node;
